import { disease, researchGroup } from '@stereoagency/sanity-schema';

export const diseaseModalQueryBuilder = disease.schema.builder
  .pick(['_id', 'name', 'content'])
  .subquery({
    researchGroups: researchGroup.schema.builder
      .filter('_id in ^.linkedResearchContent[]._ref')
      .pick(['_id', 'slug', 'title'])
      .map((resolver) => ({
        researchGroupLeader: resolver.researchGroupLeader
          .resolve(['_id', 'name', 'firstName', 'image'])
          .use()
      }))
      .use()
  });
